module.exports = __webpack_public_path__ + "static/img/noimg_banner.fbb38bb1.png";